'use strict';
/**
 * This stores the checkboxes as a comma-delimited string
 */

angular.module('msUtility').directive('msCheckboxes', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    scope: {},
    require: 'ngModel',
    link: function link(scope, ele, attrs, ngModel) {
      scope.$watch('$last', function () {
        var boxes = ele.find('input:checkbox');
        boxes.change(function () {
          var viewValue = '';
          boxes.each(function () {
            if (this.checked) {
              var val = this.getAttribute('value');
              viewValue = viewValue + val + ',';
            }
          });
          ngModel.$setViewValue(viewValue);
        });
      });
      ngModel.$render = function () {
        $timeout(function () {
          if (ngModel.$viewValue) {
            var valueArray = ngModel.$viewValue.split(',');

            var boxes = ele.find('input:checkbox');
            boxes.each(function () {
              var val = this.getAttribute('value');
              this.checked = _.includes(valueArray, val);
            });
          }
        });
      };
    }
  };
}]);